import React, { useEffect, useState } from "react";
import { GoogleMap, LoadScript, Marker, Circle } from "@react-google-maps/api";
import { IndexUse } from "./IndexUse";
import { useDispatch } from "react-redux";
import Section_title from "../../common-components/section-title/Section_title";

const Country = () => {
  const dispatch = useDispatch();
  const { country } = IndexUse();
  const heatMapData = country?.data?.bookingInPincode || [];
  const topBookingPlaces = country?.data?.topBookingPlaces || [];
  const onlineDrivers = country?.data?.onlineDrivers || [];

  const city = "Pune";
  const defaultCenter = { lat: 18.5204, lng: 73.8567 }; // Default Pune
  const [mapCenter, setMapCenter] = useState(defaultCenter);
  const [markers, setMarkers] = useState([]);
  const [topPlaces, setTopPlaces] = useState([]);

  const GOOGLE_MAPS_API_KEY = "AIzaSyCGySRnXP7VCuFGxzTFGawoyROcM3rfJKk";

  // Geocode bookingInPincode
  const geocodePincodes = async () => {
    const results = await Promise.all(
      heatMapData?.map(async (item) => {
        try {
          const response = await fetch(
            `https://maps.googleapis.com/maps/api/geocode/json?address=${item.pincode}&region=in&key=${GOOGLE_MAPS_API_KEY}`
          );
          const data = await response.json();
          if (data.status === "OK" && data.results.length > 0) {
            const { lat, lng } = data.results[0].geometry.location;
            return { ...item, lat, lng };
          }
        } catch (error) {
          console.error(`Geocode error for ${item.pincode}`, error);
        }
        return null;
      })
    );

    const validMarkers = results.filter(Boolean);
    setMarkers(validMarkers);

    if (validMarkers.length > 0) {
      setMapCenter({ lat: validMarkers[0].lat, lng: validMarkers[0].lng });
    }
  };

  // Geocode topBookingPlaces
  const geocodeTopPlaces = async () => {
    const results = await Promise.all(
      topBookingPlaces?.map(async (item) => {
        try {
          const response = await fetch(
            `https://maps.googleapis.com/maps/api/geocode/json?address=${item.pincode}&region=in&key=${GOOGLE_MAPS_API_KEY}`
          );
          const data = await response.json();
          if (data.status === "OK" && data.results.length > 0) {
            const { lat, lng } = data.results[0].geometry.location;
            return { ...item, lat, lng };
          }
        } catch (error) {
          console.error(`Geocode error for top place ${item.pincode}`, error);
        }
        return null;
      })
    );

    setTopPlaces(results.filter(Boolean));
  };

  useEffect(() => {
    if (heatMapData?.length > 0) geocodePincodes();
    if (topBookingPlaces?.length > 0) geocodeTopPlaces();
  }, [heatMapData, topBookingPlaces]);

  // Circle animation settings
  const [opacity, setOpacity] = useState(0.3);
  useEffect(() => {
    const interval = setInterval(() => {
      setOpacity((prev) => (prev === 0.3 ? 0 : 0.3));
    }, 500);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="content_body section_box">
      <div className="col-md-12">
        <Section_title title="Cab Heat Map" alltotal="" />
      </div>
      <h4>Map of {city}, Maharashtra</h4>
      <LoadScript googleMapsApiKey={GOOGLE_MAPS_API_KEY}>
        <GoogleMap
          mapContainerStyle={{ width: "100%", height: "450px" }}
          center={mapCenter}
          zoom={12}
        >
          {markers?.map((marker, index) => (
            <Marker
              key={index}
              position={{ lat: marker.lat, lng: marker.lng }}
              label={marker.count.toString()}
              title={`${marker.area} (${marker.pincode})`}
            />
          ))}

          {topPlaces?.map((place, index) => (
            <Circle
              key={`circle-${index}`}
              center={{ lat: place.lat, lng: place.lng }}
              radius={500}
              options={{
                strokeColor: "#FF0000",
                strokeOpacity: 0.3,
                strokeWeight: 2,
                fillColor: "#FF0000",
                fillOpacity: opacity,
                className: "pulsate-fwd",
              }}
            />
          ))}

          {onlineDrivers?.map((driver, index) => (
            <Marker
              key={`online-${index}`}
              position={{
                lat: parseFloat(driver.location.lat),
                lng: parseFloat(driver.location.long),
              }}
              label={{
                text: driver.name || "Online Driver",
                fontSize: "12px",
                fontWeight: "bold",
                color: "#0c6efc",
              }}
              title={`${driver.name} - ${driver.location.area} (${driver.location.pincode})`}
              icon={{
                url: "/assets/images/icons/clipart1961098.png",
                scaledSize: new window.google.maps.Size(50, 50),
                origin: new window.google.maps.Point(0, 0),
                anchor: new window.google.maps.Point(20, 40),
              }}
            />
          ))}
        </GoogleMap>
      </LoadScript>

      <div className="row mt-4">
        <div className="col-lg-6 mb-3">
          <h5 className="mb-0">Bookings</h5>
          <div className="table_section theme_bg">
            <div className="table-responsive">
              <table className="table table-bordered table-striped">
                <thead>
                  <tr>
                    <th>Area</th>
                    <th>Count Of Booking</th>
                    <th>Pincode</th>
                  </tr>
                </thead>
                <tbody>
                  {heatMapData?.length > 0 ? (
                    heatMapData?.map((val, index) => (
                      <tr key={index}>
                        <td>{val?.area}</td>
                        <td>{val?.count}</td>
                        <td>{val?.pincode}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="3" className="text-center">
                        No Data
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div className="col-lg-6 mb-3">
          <h5 className="mb-0">Online Drivers</h5>
          <div className="table_section theme_bg">
            <div className="table-responsive">
              <table className="table table-bordered table-striped">
                <thead>
                  <tr>
                    <th>Driver Name</th>
                    <th>Area</th>
                    <th>Pincode</th>
                  </tr>
                </thead>
                <tbody>
                  {onlineDrivers?.length > 0 ? (
                    onlineDrivers?.map((val, index) => (
                      <tr key={index}>
                        <td>{val?.name}</td>
                        <td>{val?.location?.area}</td>
                        <td>{val?.location?.pincode}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="3" className="text-center">
                        No Data
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Country;
